import { createContext } from 'react';

// Context for stable callbacks to prevent re-renders
export const TreeContext = createContext(null);
